export interface AppState {
  sidebarShow: string;
  token: string | null;
  currentRoute: string | null;
  languageListEditCategoryId: string | null;
  language: {
    lang: string;
    name: string | null | undefined;
    flag: string | undefined;
  };
  navigation: Array<string>;
  languageList: Array<{
    languageId: string;
    languageName: string;
    languageCode: string;
  }>;

  languageListEdit: Array<{
    languageId: string;
    languageName: string;
    languageCode: string;
    languageValue: string;
  }>;

  clientTable: Array<{
    serialNumber: number | null | undefined;
    clientName: string | null | undefined;
    clientCode: string | null | undefined;
    userName: string | null | undefined;
    UpperLevel: string | null | undefined;
    availableBalance:
      | Array<{
          currency: string | null | undefined;
          balance: string | string | null | undefined;
        }>
      | null
      | undefined;
    currency: string | null | undefined;
    RegisteredDate: string | null | undefined;
  }>;

  accountTable: Array<{
    accountId: string | null | undefined;
    accountName: string | null | undefined;
    operatorAccountType: string | null | undefined;
    status: string | null | undefined;
    currency: string | null | undefined;
    credit: string | null | undefined;
  }>;
  operatorPlayerTable: Array<{
    playerUserId: string | null | undefined;
    playerName: string | null | undefined;
    operatorUserId: string | null | undefined;
    totalBet: string | null | undefined;
    totalWin: string | number | null | undefined;
    totalMargin: string | number | null | undefined;
    avarageRTP: string | number | null | undefined;
  }>;
  breadCrumbArray: Array<{
    name: string | null | undefined;
    link: string | null | undefined;
    state: object | null | undefined;
  }>;
  gameCategoryTable: Array<{
    categoryId: string;
    serialNumber: number | null | undefined;
    categoryName: string | null | undefined;
    status: string | null | undefined;
  }>;
  role: string | null | undefined;
  upperLevel: string | null | undefined;

  searchClientDetails: {
    client_name: string | null | undefined;
    username: string | null | undefined;
    clientCode: number | null | undefined;
    balance: Array<{
      _id: string | null | undefined;
      total_available_balance: string | string | null | undefined;
    }>;
    registeredDate: string | null | undefined;
  } | null;

  searchUserDetails: {
    username: string | null | undefined;
    userId: string | null | undefined;
    registeredDate: string | null | undefined;
  } | null;

  searchClientUserHierarchy: Array<{
    clientUserName: string | null | undefined;
    clientName: string | null | undefined;
    clientId: string | null | undefined;
  }>;
  providerList: Array<{
    value: string | null | undefined;
    providerId: string | null | undefined;
    providerName: string | null | undefined;
    categories: Array<{
      category_id: string;
      category_name: Record<string, string>;
    }>;
  }>;
  subProviderList: Array<{
    subProviderId: string | null | undefined;
    subProviderName: string | null | undefined;
  }>;
  categoryList: Array<{
    categoryId: string | null | undefined;
    categoryName: string | null | undefined;
  }>;
  gameList: Array<{
    id: string | null | undefined;
    serialNumber: string | null | undefined;
    image: string | null | undefined;
    imageSquare?: string | null | undefined;
    gameName: string | null | undefined;
    gameId: string | null | undefined;
    category: string | null | undefined;
    code: string | null | undefined;
    rtp: number | null | undefined;
    provider: string | null | undefined;
    subProvider: string | null | undefined;
    status: string | null | undefined;
  }>;
  gameListModifyFormFields: {
    game_id: string | null | undefined;
    game_code: string | null | undefined;
    rtp: number | null | undefined;
    ext_game_id: string | null | undefined;
    provider_id: string | null | undefined;
    provider_name: string | null | undefined;
    provider_module: string | null | undefined;
    provider_module_name: string | null | undefined;
    category: string | null | undefined;
    category_name: string | null | undefined;
    image: string | null | undefined;
    image_square?: string | null | undefined;
    game_image_square?: string | null | undefined;
    is_featured: boolean | null | undefined;
    is_popular: boolean | null | undefined;
  } | null;

  providerInstruction: string | null;

  ProviderViewDetails: {
    _id: string;
    provider_id: string | null | undefined;
    module_id: string;
    game_provider_name: Array<{
      _id: string;
      language_name: string;
      language_code: string;
      language_value: string;
    }>;
    is_subprovider: boolean;
    game_categories: Array<{
      Category_id: string;
      Category_name: string;
    }>;
    is_betrange_allowed: string;
    betrange_info: any[];
    currency_account_type: string | null | undefined;
    currency: any[];
    logo: string;
    lobby_image: string;
    resale_price: number;
    game_category: any[];
    total_games: number;
    provider_account_technicals: any[];
    status: string;
    instruction: string | null | undefined;
  };
  ProviderCurrencyDetails: Array<{
    _id: string | null | undefined;
    currency_code: string | null | undefined;
    status: string | null | undefined;
  }>;

  upperLebelClientList: Array<{
    upperLebelClientName: string | null | undefined;
    upperLebelClientId: string | null | undefined;
    username: string | null | undefined;
  }>;
  lowerLebelClientList: Array<{
    lowerLebelClientName: string | null | undefined;
    lowerLebelClientId: string | null | undefined;
    username: string | null | undefined;
  }>;
  upperLebelAccountList: Array<{
    upperLebelAccountName: string | null | undefined;
    upperLebelAccountId: string | null | undefined;
    currency: string | null | undefined;
  }>;
  lowerLebelAccountList: Array<{
    lowerLebelAccountName: string | null | undefined;
    lowerLebelAccountId: string | null | undefined;
    currency: string | null | undefined;
  }>;
  providerReportList: Array<{
    serialNumber: string | null | undefined;
    avarageRTP: string | null | undefined;
    totalBet: string | null | undefined;
    totalMargin: string | null | undefined;
    totalWin: string | null | undefined;
    provider: string | null | undefined;
    subProvider: string | null | undefined;
  }>;
  totalProviderReportList: {
    totalBet: string | null | undefined;
    avarageRTP: string | null | undefined;
    totalMargin: string | null | undefined;
    totalWin: string | null | undefined;
  };
  totalCategoryReportList: {
    totalBet: string | null | undefined;
    avarageRTP: string | null | undefined;
    totalMargin: string | null | undefined;
    totalWin: string | null | undefined;
  };
  categoryReportList: Array<{
    serialNumber: string | null | undefined;
    avarageRTP: string | null | undefined;
    totalBet: string | null | undefined;
    totalMargin: string | null | undefined;
    totalWin: string | null | undefined;
    provider: string | null | undefined;
    category: string | null | undefined;
  }>;
  revenueReportList: Array<{
    serialNumber: string | null | undefined;
    avarageRTP: string | null | undefined;
    totalBet: string | null | undefined;
    totalMargin: string | null | undefined;
    totalWin: string | null | undefined;
    totalRebate: string | null | undefined;
    totalRevenueBeforeRebate: string | null | undefined;
    provider: string | null | undefined;
  }>;
  totalRevenueReportList: {
    totalBet: string | null | undefined;
    avarageRTP: string | null | undefined;
    totalMargin: string | null | undefined;
    totalWin: string | null | undefined;
    totalRebate: string | null | undefined;
    totalRevenueBeforeRebate: string | null | undefined;
  };
  gameCategoryReportList: Array<{
    serialNumber: string | null | undefined;
    gameName: string | null | undefined;
    gameCode: string | null | undefined;
    gameId: string | null | undefined;
    avarageRTP: string | null | undefined;
    totalBet: string | null | undefined;
    totalMargin: string | null | undefined;
    totalWin: string | null | undefined;
    provider: string | null | undefined;
    subProvider: string | null | undefined;
    category: string | null | undefined;
    period: string | null | undefined;
  }>;
  providerTransactionReportList: Array<{
    serialNumber: string | null | undefined;
    reportData: string[] | null | undefined;
    totalData: {
      total_bet: string | number | undefined | null;
      total_win: string | number | undefined | null;
      total_margin: string | number | undefined | null;
      average_rtp: string | number | undefined | null;
    };
  }>;
  totalGameCategoryReportList: {
    totalBet: string | null | undefined;
    avarageRTP: string | null | undefined;
    totalMargin: string | null | undefined;
    totalWin: string | null | undefined;
  };
  allMainProvidersList: Array<{
    id: string | null | undefined;
    serialNumber: string | null | undefined;
    providerId: string | null | undefined;
    providerName: string | null | undefined;
    subProviderCount: string | null | undefined;
    currencyInfo: string[] | null | undefined;
    supportedCurrencyType: string | null | undefined;
    category: string[] | null | undefined;
    logo: string | null | undefined;
    status: string | null | undefined;
  }>;
  allGameUploadList: Array<{
    id: string | null | undefined;
    serialNumber: string | null | undefined;
    categoryId: string | null | undefined;
    providerId: string | null | undefined;
    gameName: string | null | undefined;
    gameCode: string | null | undefined;
    gameImage: string | null | undefined;
    gameImageSquare?: string | null | undefined;
    isError: boolean | null | undefined;
    description: string | null | undefined;
    provider_name: string | null | undefined;
  }>;
  providerAccounts: Array<{
    id: string;
    accountValue: string | undefined | null;
  }>;

  adminSetting: {
    setting: {
      id: string;
      eggResalePrice: string | number | undefined | null;
    };
    currency: Array<{
      id: string;
      currencyCode: string | undefined | null;
      status: string | undefined | null;
    }>;
  };
  balanceLog: {
    balanceDetails: {
      availableBalance: string | undefined | null;
      lastUpdated: string | undefined | null;
    };
    transactionDetails: Array<{
      availableBalance: string | undefined | null;
      credit: string | undefined | null;
      date: string | undefined | null;
      debit: string | undefined | null;
      notes: string | undefined | null;
    }>;
  };
  assignInActiveProvider: {
    clientList: Array<{
      label: string | undefined | null;
      value: string;
      username: string | undefined | null;
    }>;
    provider: Array<{
      providerId: string;
      serialNumber: number | string;
      providerName: string | undefined | null;
      isSubProvider: boolean | undefined | null;
      subProviderName: string | null;
      providerLogo: string | undefined;
      mapped: boolean;
    }>;
  };

  assignProviderList: Array<{
    providerId: string | null | undefined;
    providerName: string | null | undefined;
    logo: string;
  }>;
  assignedProviderTable: Array<{
    game_provider_id: string | null | undefined;
    game_provider_name: string | null | undefined;
    mapped: boolean | null | undefined;
  }>;
  childClientList: Array<{ label: string | undefined | null; value: string }>;
  currencyCode: string | undefined | null;
  walletBalance: string | undefined | null;

  assignProviderAccountList: Array<{
    _id: string;
    name: string | undefined | null;
    selected: { value: string; label: string } | null;
    accounts: Array<{
      value: string;
      label: string;
      selected: boolean | undefined;
    }>;
  }>;
  allMasterPlayerList: Array<{
    accountId: string | undefined | null;
    externalId: string | undefined | null;
    playerId: string | undefined | null;
    status: string | undefined | null;
    userName: string | undefined | null;
    lastLogIn: string | undefined | null;
    registerDate: string | undefined | null;
    currency: string | undefined | null;
  }>;
  playerLog: Array<{
    accountId: string;
    userId: string;
    externalUserId: string;
    transactionId: string;
    action: string;
    amount: string;
    availableBalance: string;
    gameDetails: string | {} | null;
    gameTitle: string;
    gameId: string;
    gameCategoryName: string;
    roundId: string;
    provider: string;
    dateTime: string;
  }>;
  playerDetails: {
    accountId: string;
    clientId: string;
    clientName: string;
    currency: string;
    externalPlayerId: string;
    lastLogIn: string;
    playerId: string;
    status: string;
    username: string;
  };
  walletReportList: Array<{
    serialNumber: string | null | undefined;
    availableBalance: string | null | undefined;
    transactionAmount: string | null | undefined;
    transactionDate: string | null | undefined;
    transactionFromAccount: string | null | undefined;
    transactionFromUser: string | null | undefined;
    transactionId: string | null | undefined;
    transactionToAccount: string | null | undefined;
    transactionToUser: string | null | undefined;
    transactionType: string | null | undefined;
  }>;
  providerAccountList: Array<{
    categoryId: string | null | undefined;
    categoryName: string[] | null | undefined;
    slNo: string | number | null | undefined;
    providerName: string | null | undefined;
    isDefault: boolean;
    providerId: string | null | undefined;
    accountId: string | null | undefined;
    accountName: string | null | undefined;
    operatorAccountType: string | null | undefined;
    status: boolean | string | null | undefined;
    currency: string[] | null | undefined;
  }>;
  currentProvider: {
    _id: string;
    name: string;
  };
  currentAccount: {
    _id: string;
    name: string;
  };
  currentSubProvider: {
    _id: string;
    name: string;
  };

  allSubProviderList: Array<{
    id: string | null | undefined;
    serialNumber: string | null | undefined;
    betRangeAllowed: string | null | undefined;
    providerName: string | null | undefined;

    currencyInfo: string[] | null | undefined;
    supportedCurrencyType: string | null | undefined;
    category: string[] | null | undefined;
    logo: string | null | undefined;
    status: string | null | undefined;
  }>;

  clientGameList: Array<{
    serialNumber: string | null | undefined;
    game_id: string | null | undefined;
    game_name: string | null | undefined;
    game_code: string | null | undefined;
    game_provider_id: string | null | undefined;
    provider_name: string | null | undefined;
    game_category_id: string | null | undefined;
    category_name: string | null | undefined;
    game_image: string | null | undefined;
    status: string | null | undefined;
    release_date: string | null | undefined;
  }>;

  searchUsersByUsernameHierarchy: Array<{
    player_id: string | null | undefined;
    account_user_id: string | null | undefined;
    username: string | null | undefined;
    currency_code: string | null | undefined;
    last_login: string | null | undefined;
    status: string | null | undefined;
    account_name: string | null | undefined;
    client_name: string | null | undefined;
  }>;

  dashboardData: {
    total_month_bet: string | null | undefined;
    total_month_win: string | null | undefined;
    total_today_bet: string | null | undefined;
    total_today_win: string | null | undefined;
  };
}

export interface Action {
	type: string;
	payload: any;
}

// types.ts
export const SET = "SET";
export const TOKEN = "TOKEN";
export const LANGUAGE = "LANGUAGE";
export const CURRENTROUTE = "CURRENTROUTE";
export const CLIENTTABLE = "CLIENTTABLE";
export const GAMECATEGORYTABLE = "GAMECATEGORYTABLE";
export const ROLE = "ROLE";
export const UPPERLEVEL = "UPPERLEVEL";
export const BREADCRUMBARRAY = "BREADCRUMBARRAY";
export const SEARCHCLIENTDETAILS = "SEARCHCLIENTDETAILS";
export const SEARCHCLIENTUSERHIERARCHY = "SEARCHCLIENTUSERHIERARCHY";
export const SEARCHUSERDETAILS = "SEARCHUSERDETAILS";
export const ACCOUNTTABLE = "ACCOUNTTABLE";
export const OPERATORPLAYERTABLE = "OPERATORPLAYERTABLE";
export const LANGUAGELIST = "LANGUAGELIST";
export const LANGUAGELISTEDIT = "LANGUAGELISTEDIT";
export const LANGUAGELISTEDITCATEGORYID = "LANGUAGELISTEDITCATEGORYID";

export const PROVIDERLIST = "PROVIDERLIST";
export const PROVIDERACCOUNTLIST = "PROVIDERACCOUNTLIST";
export const CURRENTPROVIDER = "CURRENTPROVIDER";
export const SUBPROVIDERLIST = "SUBPROVIDERLIST";
export const CATEGORYLIST = "CATEGORYLIST";
export const GAMELIST = "GAMELIST";
export const GAMELISTMODIFYFORMFIELDS = "GAMELISTMODIFYFORMFIELDS";
export const PROVIDERINSTRUCTION = "PROVIDERINSTRUCTION";
export const PROVIDERVIEWDETAILS = "PROVIDERVIEWDETAILS";
export const PROVIDERCURRENCYDETAILS = "PROVIDERCURRENCYDETAILS";
export const PROVIDERACCOUNTS = "PROVIDERACCOUNTS";
export const ALLMAINPROVIDERSLIST = "ALLMAINPROVIDERSLIST";
export const ALLGAMEUPLAODLIST = "ALLGAMEUPLOADLIST";

export const UPPERLEBELCLIENLIST = "UPPERLEBELCLIENTLIST";
export const LOWERLEBELCLIENTLIST = "LOWERLEBELCLIENTLIST";
export const UPPERLEBELACCOUNTLIST = "UPPERLEBELACCOUNTLIST";
export const LOWERLEBELACCOUNTLIST = "LOWERLEBELACCOUNTLIST";
export const PROVIDERREPORTLIST = "PROVIDERREPORTLIST";
export const TOTALPROVIDERREPORTLIST = "TOTALPROVIDERREPORTLIST";
export const CATEGORYREPORTLIST = "CATEGORYREPORTLIST";
export const TOTALCATEGORYREPORTLIST = "TOTALCATEGORYREPORTLIST";
export const TOTALGAMECATEGORYREPORTLIST = "TOTALGAMECATEGORYREPORTLIST";
export const PROVIDERTRANSACTIONREPORTLIST = 'PROVIDERTRANSACTIONREPORTLIST';
export const GAMECATEGORYREPORTLIST = "GAMECATEGORYREPORTLIST";
export const REVENUEREPORTLIST = "REVENUEREPORTLIST";
export const TOTALREVENUEREPORTLIST = "TOTALREVENUEREPORTLIST";
export const ADMINSETTING = "ADMINSETTING";

export const GETCURRENCYCODE = "GETCURRENCYCODE";

export const GETWALLETBALANCE = "GETWALLETBALANCE";
export const GETBALANCELOG = "GETBALANCELOG";

export const GETASSIGNINACTIVEPROVIDER = "GETASSIGNINACTIVEPROVIDER";
export const GETASSIGNPROVIDERLIST = "GETASSIGNPROVIDERLIST";
export const GETCHILDCLIENTLIST = "GETCHILDCLIENTLIST";

export const GETASSIGNPROVIDERACCOUNTLIST = "GETASSIGNPROVIDERACCOUNTLIST";

export const GETALLMASTERPLAYERLIST = "GETALLMASTERPLAYERLIST";
export const GETPLAYERDETAILS = "GETPLAYERDETAILS";
export const WALLETREPORTLIST = "WALLETREPORTLIST";
export const GETPLAYERLOG = "GETPLAYERLOG";
export const CURRENTACCOUNT = "CURRENTACCOUNT";
export const CURRENTSUBPROVIDER = "CURRENTSUBPROVIDER";
export const GETSUBPROVIDERLSIT = " GETSUBPROVIDERLSIT";
export const ASSIGNPROVIDERTABLE = "ASSIGNPROVIDERTABLE";
export const CLIENTGAMELIST = "CLIENTGAMELIST";

export const CLEAR = "CLEAR";

export const DASHBOARDDATA = "DASHBOARDDATA";

export const SEARCHUSERSBYUSERNAMEHIERARCHY = "SEARCHUSERSBYUSERNAMEHIERARCHY";

export const NAVIGATION = "NAVIGATION"